import BackButton from '@/components/back-button/back-button.component';
import Image from 'next/image';
import './not-found.scss';

export default function NotFoundPage() {
    return (
        <div className="container-notfound" data-testid="container-notfound" id="container-notfound">
            <div className="image-container" data-testid="image-container" id="image-container">
                <Image
                    src={`${process.env.NEXT_PUBLIC_ASSETS_PATH}/assets/img/not-found-error.webp`}
                    width={504}
                    height={208}
                    title="Conteúdo não encontrado"
                    alt="Conteúdo não encontrado"
                    priority
                    className='image-notfound'
                    data-testid="image-notfound"
                    id="image-notfound"
                />
            </div>
            <div className="info" data-testid="info" id="info">
                <h1 data-testid="error-title" id="error-title">Ops, ocorreu um erro inesperado.</h1>
                <p data-testid="error-message" id="error-message">Parece que a página que você estava procurando sofreu um pequeno acidente no meio do caminho</p>
            </div>
            <BackButton />
        </div>
    );
}
